
/* injects from baggage-loader */

'use strict';

import AddCardComponent from './add-card.component';
import './add-card.scss';

const AddCardModule = angular.module('add-card-module', []);

AddCardModule
    .component('addCard', new AddCardComponent());

export default AddCardModule;




// WEBPACK FOOTER //
// ./src/app/components/add-card/add-card.module.js